import React, {Component} from 'react';
import onClickOutside from 'react-onclickoutside';

import {autoCapital, hideElementAfterDelay, addClass, removeClass, scrollToContent} from "../../../../utils/common";
import './style.scss'


class Dropdown extends Component {
    constructor(props){
        super(props);
        let {getValue, defaultSelected, dropdownOptions, fromECartJourney} = props;
        this.state={
            dropDownValue:defaultSelected?(getValue?defaultSelected.value:defaultSelected):'',
            dropDownKey:defaultSelected?(getValue?defaultSelected.name:defaultSelected):'',
            dropdownSearch: '',
            dropdownOptions: dropdownOptions || [],
            hide: true,
        }
        this.selectorRef = React.createRef(null);
    }

    componentDidMount() {
        let { isBannerDropdown } = this.props;
        isBannerDropdown && window.addEventListener("mousedown", this.handleClickedOutside);
        document.addEventListener("mousedown", this.handleOutsideClick);
    }

    handleClickOutside = (event) => {
        let { name, dropdownOptions, isBannerDropdown } = this.props;
        this.scrollbar && this.scrollbar.scrollToTop();

        let element = document.getElementsByClassName("options") && document.querySelector(".options[name="+name+"]");
        //if(event.target.id != 'dd_options' && element && element.style.display == "block" ){
        /*if(element && element.style.display == "block" ){
            element.style.display="none";
        }*/
        !isBannerDropdown && hideElementAfterDelay(element,0);
        this.setState({
            hide: true
        });
        // !isBannerDropdown && this.setState({ dropdownOptions: dropdownOptions, dropdownSearch: '' , hide: !this.state.hide });
    };

    dropDownState=(event)=>{
        let { name, getValue=false } = this.props;
        let value = event.target.getAttribute('data-value');
        //this.ignoreDefault = true;
        if (value) {
            if(getValue){
                value = JSON.parse(value);
                this.setState({
                    dropDownValue:value.value,
                    dropDownKey: value.name,
                    hide: !this.state.hide
                })
            }
            else {
                this.setState({
                    dropDownValue: value,
                    hide: !this.state.hide
                })
            }
        }

        //document.querySelector(".options[name="+name+"]").style.display='none';
        this.handleClickOutside();
        this.props.onSelect && this.props.onSelect(value);

    };

    componentWillReceiveProps(props){
        let {defaultSelected, getValue, resetDropdown, dropdownOptions} = props;
        this.ignoreDefault = !resetDropdown;
        if(dropdownOptions && dropdownOptions.length) {
            this.setState({ dropdownOptions: dropdownOptions, dropdownSearch: '' });
        }
        //if(!this.ignoreDefault) {
            defaultSelected !== undefined && this.setState({
                dropDownValue: defaultSelected ? (getValue ? defaultSelected.value : defaultSelected) : '',
                dropDownKey: defaultSelected ? (getValue ? defaultSelected.name : defaultSelected) : '',
            });
        //}
    }

    selectOption=(event)=>{
        let code = (event.keyCode ? event.keyCode : event.which);
        let {name} = this.props;
        if(__CLIENT__) {
            if (code == 40 || code == 38) {
                event.preventDefault();
                let options = document.querySelector(".options[name='"+name+"']");
                if(options && options.style.display!='block'){
                    options.style.display = 'block';
                }
                let hovered = document.querySelector(".options[name='" + name + "'] li.hovered"), elementToHover;
                if (!hovered) {
                    elementToHover = document.querySelector(".options[name='" + name + "'] li:first-of-type");
                }
                else {
                    if (code == 40) {
                        elementToHover = hovered.nextSibling ? hovered.nextSibling
                            : document.querySelector(".options[name='" + name + "'] li:first-of-type");
                    }
                    else if (code == 38) {
                        elementToHover = hovered.previousSibling ? hovered.previousSibling
                            : document.querySelector(".options[name='" + name + "'] li:last-of-type");
                    }
                }
                this.removeHover();
                addClass(elementToHover, 'hovered');
                let listOfOptions = document.querySelectorAll(".options[name='"+name+"'] li")
                for(let i=0; i<listOfOptions.length;i++){
                    if(listOfOptions[i]==elementToHover)
                        this.scrollbar.scrollTop(37.5*(i-2));
                }
            }
            else if(code > 64 && code < 91){
                event.preventDefault();
                this.filterFunction(event, code);
            }
            else if(code==13){
                event.preventDefault();
                let hovered = document.querySelectorAll(".options[name='" + name + "'] li.hovered")[0];
                hovered && this.dropDownState({target:hovered})
            }
        }
    };

    hoverIn=(event)=>{
        let element = event.target;
        addClass(element,'hovered')
    };

    removeHover=()=>{
        if(__CLIENT__){
            let {name} = this.props;
            let elements = document.querySelectorAll(".options[name='"+name+"'] li.hovered");
            if(elements.length){
                for(let element of elements){
                    removeClass(element,'hovered');
                }
            }
        }
    };

    /*function to filer the list elements*/
    filterFunction = (e, code) => {
        // let inputValue = e.target.value.toUpperCase();
        let inputValue = String.fromCharCode(code);
        let data = this.props.dropdownOptions;
        let array = [];
        for(let i =0; i<data.length; i++) {
            if(data[i]['name'].toUpperCase().indexOf(inputValue ) > -1) {
                array.push(data[i]);
            }
        }
        this.setState({ dropdownOptions: array, dropdownSearch: e.target.value });
    };

    toggleDropDown = () => {
        this.setState({
            hide: !this.state.hide,
        })
    }

    handleClickedOutside = (e) => {
        if (this.state.hide === false && this.selectorRef.current && !this.selectorRef.current.contains(e.target)) {
            this.setState({
                hide: !this.state.hide,
            })
        }
    }

    handleOutsideClick = (e) => {
        if (this.state.hide === false && this.selectorRef.current && !this.selectorRef.current.contains(e.target)) {
            this.setState({
                hide: true,
            })
        }
    }

    componentWillUnmount() {
        let { isBannerDropdown } = this.props;
        isBannerDropdown && window.removeEventListener("mousedown", this.handleClickedOutside);
        document.addEventListener("mousedown", this.handleOutsideClick);
    }


    render(){
        let {dropdownLabel,name, getValue=false, requiredValue=true, sort=false, isAutocapital=true, placeholder, isBannerDropdown,activeLang}=this.props,
            {dropdownSearch, dropdownOptions, hide} = this.state

        let heightOfOptions, liStyle, dropdownContent;
        if(dropdownOptions) {
            //added height if there nis no value in dropdown
            heightOfOptions = dropdownOptions.length < 5 ? dropdownOptions.length==0 || dropdownOptions.length==1 ?
                '':3.1 * dropdownOptions.length + 0.4 + 'em' : '166px'; // 4.5 options visible at a time.

            liStyle = {};
            // Object.assign(liStyle,
            //     dropdownOptions.length < 5 && {style:{margin: '0', padding: '10px'}}
            // );
            if(dropdownOptions && sort){
                dropdownContent = dropdownOptions.slice(0).reverse().map((item, idx) => {
                    return <li id='dd_options' className="dropdown-item" {...liStyle} data-value={getValue ? JSON.stringify(item) : item.name}
                               onMouseEnter={this.hoverIn}
                               onMouseLeave={this.removeHover}
                               key={idx}
                               role="menuitem" tabIndex="0"
                               onClick={this.dropDownState}
                               onKeyPress={this.dropDownState}>
                        {isAutocapital?autoCapital(item.name):item.name}
                    </li>
                });
            }
            else {
                dropdownContent = dropdownOptions.map((item, idx) => {
                    return <li id='dd_options' className="dropdown-item" {...liStyle} data-value={getValue ? JSON.stringify(item) : item.name}
                               onMouseEnter={this.hoverIn}
                               onMouseLeave={this.removeHover}
                               key={idx}
                               role="menuitem" tabIndex="0"
                               onClick={this.dropDownState}
                               onKeyPress={this.dropDownState}>
                        {isAutocapital? autoCapital(item.name): item.name}
                    </li>
                });
            }


        }

        return(
            <div ref={this.selectorRef} className={!hide && isBannerDropdown ? 'dropdown shown' : `dropdown ${activeLang}`}>
                <input type="text" name={name+"Input"}
                       placeholder={placeholder}
                       data-toggle="dropdown"
                       tabIndex="0" role="menuitem"
                       value={isBannerDropdown ? (!hide ? "" : this.state.dropDownKey) : isAutocapital?autoCapital(!getValue ? this.state.dropDownValue: this.state.dropDownKey):!getValue ? this.state.dropDownValue: this.state.dropDownKey} readOnly="readonly"
                       onClick={this.toggleDropDown}
                       onBlur={(event)=>{event.target.value != '' ?'': requiredValue ?event.target.classList.add('error'):''}}
                       className={this.state.dropDownValue != '' && hide ? 'active': 'toggle-input'}
                       onKeyDown={this.selectOption}
                       disabled={this.props.disabled ? this.props.disabled : false} />
                {dropdownOptions && dropdownOptions.length>0 ?
                <ul name={name} className={this.props.fromECartJourney && hide ? "options dropdown-menu" : this.props.fromECartJourney && !hide ? "options toggle-options dropdown-menu dropdown-menuList" : hide ? "options dropdown-menu" : "options toggle-options dropdown-menu"} style={hide ? {display: 'none'} : {height: heightOfOptions}}>
                    {/* <li>
                        <input placeholder="Search" type="text"
                               autoFocus="true"
                               style={{ color: '#333',
                                   fontWeight: '600' }}
                               onChange={this.filterFunction}
                               value={dropdownSearch}
                        />
                    </li> */}
                    {dropdownOptions.length>4 ?
                        <div className='parentdropdown'>
                            <div className='maindropdown'>
                                {dropdownContent}
                            </div>
                        </div>
                        :
                        <div>
                            {dropdownContent}
                        </div>
                    }
                </ul>:   <ul name={name} className="options dropdown-menu" style={{display: 'none', height: heightOfOptions}}>
                        {/* <li>
                            <input placeholder="Search" type="text"
                                   autoFocus="true"
                                   style={{ color: '#333',
                                       fontWeight: '600' }}
                                   onChange={this.filterFunction}
                                   value={dropdownSearch}
                            />
                        </li> */}
                        <li id='dd_options' style={{ borderTop: 'none' }}>No content</li>
                </ul>
                }
                {dropdownLabel? <label className={this.props.disabled? 'disabled-label':''}>{dropdownLabel} {requiredValue && <span className="asterick">*</span>}</label>: ''}
            </div>
        )
    }}

export default Dropdown;
